import ProfilePageView from './ProfilePageView';

export default ProfilePageView;
